<template>
  <LoadingCard
    :loading="loading"
    class="p-4">
    <h3 v-if="label !== null" class="font-normal">{{ label }}</h3>

    <div class="mt-6">
      <h2
        class="text-5xl inline font-museo"
        :class="{'cursor-pointer': this.$listeners && this.$listeners.numberClick }"
        :style="{color: color}"
        @click="$emit('numberClick')"
      >{{ formattedNumber }}</h2>
      <span v-if="hasPercentage" class="ml-2 text-80">({{ formattedPercentage }})</span>
    </div>
  </LoadingCard>
</template>

<script>
  import LoadingCard from '@/_legacy/components/LoadingCard.vue';

  export default {
    name: 'NumberCard',
    components: { LoadingCard },

    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: null,
      },
      number: {
        type: Number,
        default: null,
      },
      percentage: {
        type: Number,
        default: null,
      },
      color: {
        type: String,
        default: 'inherit',
      },
    },

    data: () => ({}),

    computed: {
      hasPercentage() {
        return this.number !== null && this.percentage !== null;
      },
      formattedNumber() {
        if (this.number) {
          return this.$n(this.number, 'analyticsInteger');
        }

        if (this.percentage) {
          return this.$n(this.percentage, 'analyticsPercentage')
            .replace(' %', '%');
        }

        return 0;
      },
      formattedPercentage() {
        return this.$n(this.percentage, 'analyticsPercentage')
          .replace(' %', '%');
      },
    },

    methods: {},
  };
</script>
